import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFacebook, FiInstagram, FiTwitter, FiPhone, FiMail, FiMapPin } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Notice Section */}
      <div className="bg-yellow-400 py-6 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-yellow-600/20">
            <p className="text-black text-sm leading-relaxed">
              <span className="text-lg">⚠️</span> <strong>Notice:</strong> This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects. 
              <span className="text-lg ml-2">🔒</span> We never share any client website made under this offer with others – your project privacy is 100% safe. 
              <span className="text-lg ml-2">👉</span> <a href="https://projects.azaansuperpc.com/" target="_blank" rel="noopener noreferrer" className="text-blue-800 font-semibold hover:underline">Check Offer</a>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Logo & Description */}
            <div className="col-span-1 lg:col-span-2">
              <motion.div 
                className="mb-6"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.2 }}
              >
                <h2 className="text-2xl font-bold bg-gradient-to-r from-red-400 via-yellow-400 to-red-400 bg-clip-text text-transparent mb-2">
                  LUXE SALON
                </h2>
                <p className="text-xs text-yellow-400 tracking-widest mb-4">BEAUTY & STYLE</p>
                <p className="text-gray-300 leading-relaxed">
                  Experience luxury and elegance at Luxe Salon. We provide premium beauty services 
                  with expert stylists and top-quality products to enhance your natural beauty.
                </p>
              </motion.div>
              
              {/* Social Media */}
              <div className="flex space-x-4">
                <motion.a 
                  href="#" 
                  whileHover={{ scale: 1.1, color: '#ef4444' }}
                  className="text-gray-400 hover:text-red-400 transition-colors duration-300"
                >
                  <SafeIcon icon={FiFacebook} className="w-5 h-5" />
                </motion.a>
                <motion.a 
                  href="#" 
                  whileHover={{ scale: 1.1, color: '#ef4444' }}
                  className="text-gray-400 hover:text-red-400 transition-colors duration-300"
                >
                  <SafeIcon icon={FiInstagram} className="w-5 h-5" />
                </motion.a>
                <motion.a 
                  href="#" 
                  whileHover={{ scale: 1.1, color: '#ef4444' }}
                  className="text-gray-400 hover:text-red-400 transition-colors duration-300"
                >
                  <SafeIcon icon={FiTwitter} className="w-5 h-5" />
                </motion.a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h3>
              <ul className="space-y-3">
                {['Home', 'About', 'Services', 'Gallery', 'Contact'].map((link) => (
                  <li key={link}>
                    <Link 
                      to={link === 'Home' ? '/' : `/${link.toLowerCase()}`}
                      className="text-gray-300 hover:text-red-400 transition-colors duration-300"
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-yellow-400">Contact Info</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="w-4 h-4 text-red-400" />
                  <span className="text-gray-300">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="w-4 h-4 text-red-400" />
                  <span className="text-gray-300">info@luxesalon.com</span>
                </div>
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FiMapPin} className="w-4 h-4 text-red-400 mt-1" />
                  <span className="text-gray-300">123 Beauty Street<br />Downtown, City 12345</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                © {currentYear} Luxe Salon. All rights reserved.
              </p>
              <p className="text-gray-400 text-sm">
                Domain + Hosting + Design = <a href="https://account4web.ca" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 transition-colors duration-300">Account4Web Inc</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;